export default __webpack_public_path__ + "static/media/location-size=8px-colour-efefef.83518d52.svg";